var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{attrs:{"label":_vm.$t('checkout.pay_now'),"classes":['p-button-lg'],"styles":'width: 100%; background-color: #40BD5E;'},on:{"click":_vm.buyByPayPal}})
}
var staticRenderFns = []

export { render, staticRenderFns }